import { render, staticRenderFns } from "./StockInformation.vue?vue&type=template&id=081a1a0e&scoped=true"
import script from "./StockInformation.vue?vue&type=script&lang=js"
export * from "./StockInformation.vue?vue&type=script&lang=js"
import style0 from "./StockInformation.vue?vue&type=style&index=0&id=081a1a0e&prod&scoped=true&lang=css"
import style1 from "./StockInformation.vue?vue&type=style&index=1&id=081a1a0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081a1a0e",
  null
  
)

export default component.exports